import { useParams } from "react-router-dom";
import { isTaskAssignment } from "tm-shared/utils";

import { useAppSelector } from "@/hooks/redux";
import NotFound from "@/routes/Pages/NotFound";

import { AssignmentTaskPage } from "./AssignmentTaskPage";

const AssignmentTask = () => {
    const { marketId, taskId } = useParams();

    const { tasks, markets } = useAppSelector((state) => state.work);

    const safeMarketId = marketId ?? "";
    const safeTaskId = taskId ?? "";

    if (!safeMarketId || !safeTaskId) return null;

    const currentTask = tasks?.[safeMarketId]?.[safeTaskId];
    const currentMarket = markets?.[safeMarketId];

    if (!currentTask || !isTaskAssignment(currentTask) || !currentMarket) {
        return <NotFound />;
    }

    return <AssignmentTaskPage task={currentTask} market={currentMarket} />;
};

export default AssignmentTask;
